:host {
  display: block;
}

.cta-price {
  display: flex;
  flex-direction: column;
  color: #333333;
}

@media screen and (max-width: 979px) {
  :host([variant=default]) .cta-price {
    justify-content: center;
    align-items: center;
  }
}

.cta-price__in-stock-label {
  color: #3dcd58;
  font-weight: bold;
  font-size: 0.875rem;
  line-height: 20px;
  margin-bottom: 4px;
}

.cta-price__material-group {
  margin-bottom: 16px;
  font-size: 0.875rem;
  line-height: 1rem;
  color: #626469;
}

.cta-price__label {
  margin-bottom: 4px;
  font-size: 0.875rem;
  line-height: 1rem;
  color: #626469;
}

:host([variant=stickyBar]) .cta-price__label {
  margin-bottom: 0;
  font-size: 0.75rem;
  line-height: 1.25rem;
}

.cta-price__text-content {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
}

:host([variant=grid]) .cta-price__text-content {
  flex-direction: column;
}

:host([variant=list]) .cta-price__text-content {
  flex-direction: column;
}

:host([variant=stickyBar]) .cta-price__text-content {
  align-items: center;
}

.cta-price__wrapper {
  display: flex;
  align-items: center;
}

@media screen and (max-width: 979px) {
  .cta-price__wrapper {
    align-items: flex-start;
    flex-direction: column;
  }

  .cta-price__wrapper .cta-price__text {
    font-size: 1.125rem;
    line-height: 2rem;
  }
}

.cta-price__bundle-label {
  color: #333333;
}

@media screen and (min-width: 980px) {
  .cta-price__bundle-label {
    font-size: 0.75rem;
    line-height: 1.25rem;
  }

  :host(:not([dir="rtl"])) .cta-price__bundle-label {
    margin-left: 4px;
  }

  :host([dir="rtl"]) .cta-price__bundle-label {
    margin-right: 4px;
  }
}

@media screen and (max-width: 979px) {
  .cta-price__bundle-label {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

@media screen and (min-width: 980px) {
  :host(.cta-area__price_filter) .cta-price__text,
:host(.cta-area__price_filter) .cta-price__previous {
    width: 100%;
  }

  :host(:not([dir="rtl"]).cta-area__price_filter) .cta-price__text,
:host(:not([dir="rtl"]).cta-area__price_filter) .cta-price__previous {
    text-align: right;
  }

  :host([dir="rtl"].cta-area__price_filter) .cta-price__text,
:host([dir="rtl"].cta-area__price_filter) .cta-price__previous {
    text-align: left;
  }
}

:host(.cta-area__price_filter) .filter_pricearea {
  width: 100%;
  display: flex;
}

:host(.cta-area__price_filter) .cta-price__previous.beside {
  margin: 0;
  line-height: 2rem;
  font-size: 16px;
  font-weight: 400;
}

@media screen and (min-width: 980px) {
  :host(.cta-area__price_filter) .cta-price__previous.beside {
    flex-shrink: 1;
  }
}

@media screen and (max-width: 979px) {
  :host(:not([dir="rtl"]).cta-area__price_filter) .cta-price__previous.beside {
    margin-right: 15px;
  }

  :host([dir="rtl"].cta-area__price_filter) .cta-price__previous.beside {
    margin-left: 15px;
  }
}

:host(.cta-area__price_filter) .cta-price__text {
  font-size: 16px !important;
}

:host(.cta-area__price_filter) .cta-price__vat-label {
  font-size: 14px;
  font-weight: 400;
}

@media screen and (min-width: 980px) {
  :host(.cta-area__price_filter) .cta-price__vat-label {
    width: 100%;
  }

  :host(:not([dir="rtl"]).cta-area__price_filter) .cta-price__vat-label {
    text-align: right;
  }

  :host([dir="rtl"].cta-area__price_filter) .cta-price__vat-label {
    text-align: left;
  }
}

@media screen and (max-width: 979px) {
  :host(.cta-area__price_filter) .cta-price__vat-label {
    margin-top: 0;
  }
}

@media screen and (max-width: 979px) {
  :host(.cta-area__price_filter) .cta-price {
    padding-bottom: 18px;
  }
}

@media screen and (min-width: 980px) {
  :host(.cta-area__price_filter) .cta-price {
    padding-bottom: 11px;
  }
}

.cta-price__text {
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;
}

@media screen and (min-width: 980px) {
  .cta-price__text {
    font-size: 2.1875rem;
    line-height: 2.5rem;
  }

  :host([variant=grid]) .cta-price__text {
    font-size: 1.125rem;
    line-height: 2rem;
  }

  :host([variant=list]) .cta-price__text {
    font-size: 1.125rem;
    line-height: 2rem;
  }
}

@media screen and (max-width: 979px) {
  .cta-price__text {
    font-size: 1.5rem;
    line-height: 1.625rem;
  }

  :host([variant=grid]) .cta-price__text {
    font-size: 1.125rem;
    line-height: 2rem;
  }

  :host([variant=list]) .cta-price__text {
    font-size: 1.125rem;
    line-height: 2rem;
  }
}

:host([variant=stickyBar]) .cta-price__text {
  font-size: 1rem;
  line-height: 1.125rem;
}

@media screen and (min-width: 980px) {
  .cta-price__text-content--secondary .cta-price__text {
    font-size: 1.5625rem;
    line-height: 1.875rem;
  }
}

@media screen and (max-width: 979px) {
  .cta-price__text-content--secondary .cta-price__text {
    font-size: 1.25rem;
    line-height: 1.5625rem;
  }
}

.cta-price__previous {
  color: #626469;
  font-size: 0.75rem;
  line-height: 1.125rem;
  font-weight: 200;
}

:host(:not([dir="rtl"])) .cta-price__previous {
  margin-left: 8px;
}

:host([dir="rtl"]) .cta-price__previous {
  margin-right: 8px;
}

@media screen and (min-width: 980px) {
  .cta-price__previous {
    margin-top: 2px;
  }

  :host([variant=grid]) .cta-price__previous {
    font-size: 0.75rem;
    line-height: 1.125rem;
  }

  :host(:not([dir="rtl"])[variant=grid]) .cta-price__previous {
    margin-left: 0;
  }

  :host([dir="rtl"][variant=grid]) .cta-price__previous {
    margin-right: 0;
  }

  :host([variant=list]) .cta-price__previous {
    font-size: 0.75rem;
    line-height: 1.125rem;
  }

  :host(:not([dir="rtl"])[variant=list]) .cta-price__previous {
    margin-left: 0;
  }

  :host([dir="rtl"][variant=list]) .cta-price__previous {
    margin-right: 0;
  }
}

@media screen and (max-width: 979px) {
  :host(:not([dir="rtl"]).cta-area__price) .cta-price__previous {
    margin-left: 0;
  }

  :host([dir="rtl"].cta-area__price) .cta-price__previous {
    margin-right: 0;
  }
}

.cta-price__vat-label {
  color: #626469;
  margin-top: 4px;
}

@media screen and (min-width: 980px) {
  .cta-price__vat-label {
    font-size: 0.75rem;
    line-height: 1.25rem;
  }
}

@media screen and (max-width: 979px) {
  .cta-price__vat-label {
    font-size: 0.75rem;
    line-height: 1.25rem;
  }
}

.cta-price__reseller-label {
  color: #3dcd58;
  margin-top: 6px;
  font-weight: bold;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

:host(:not([dir="rtl"])) .cta-price__tooltip-icon {
  margin-left: 8px;
}

:host([dir="rtl"]) .cta-price__tooltip-icon {
  margin-right: 8px;
}

@media screen and (min-width: 980px) {
  :host(:not([variant=stickyBar])) .cta-price__tooltip-icon {
    margin-top: 2px;
  }
}